export default __webpack_public_path__ + "static/media/design4.9fe8bba3.png";